<template>
  <!-- 延迟显示 loading 效果。当 spinning 状态在 delay 时间内结束，则不显示 loading 状态。 -->
  <a-spin :spinning="spinning" :delay="200">
    <!-- echarts 图表 -->
    <div ref="chartRef" class="home-echarts-content" v-show="showECharts"></div>
    <dc-layout-empty type="nothing" v-if="!showECharts" />
  </a-spin>
  <!--  <div class="home-echarts-wrap" :style="{ width, height, marginBottom }">-->
  <!--    <div class="home-echarts-header" style="padding: 10px 24px 0 24px;height: auto">-->
  <!--      <h3 class="home-echarts-header__title">{{ title }}</h3>-->
  <!--      <a-date-picker-->
  <!--        v-model:value="monthValue"-->
  <!--        :allowClear="false"-->
  <!--        @change="handleDateChange"-->
  <!--        picker="month"-->
  <!--      />-->
  <!--    </div>-->
  <!--    &lt;!&ndash; 延迟显示 loading 效果。当 spinning 状态在 delay 时间内结束，则不显示 loading 状态。 &ndash;&gt;-->
  <!--    <a-spin :spinning="spinning" :delay="200">-->
  <!--      &lt;!&ndash; echarts 图表 &ndash;&gt;-->
  <!--      <div ref="chartRef" class="home-echarts-content" v-show="showECharts"></div>-->
  <!--      <dc-layout-empty type="nothing" v-if="!showECharts"/>-->
  <!--    </a-spin>-->
  <!--  </div>-->
</template>

<script setup lang="ts">
import { ref, onBeforeMount, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { Ref, PropType } from 'vue'
import { getAlarmLevelDistribution, getAlarmTypeDistribution } from '@/api/gucangSales/regionDataBoard'
import dayjs, { Dayjs } from 'dayjs'
import { getMonthDays } from '@/utils/timeFormat'
import { colors } from '../../dataConfig'

interface ItemCommonType {
  name: string
  quantity: number
  total: number
  prop: string
}
const props = defineProps({
  title: {
    type: String as PropType<string>,
    default: '异动类型分布'
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  // 情况类型 默认是异动类型 1 异动等级2
  distributionType: {
    type: String as PropType<string>,
    default: '1'
  },
  formState: {
    type: Object as PropType<Object>
  }
})

const spinning = ref(false)
const showECharts = ref(false)
const monthValue = ref<Dayjs>(dayjs())
const levelNames = ['一级异动', '二级异动', '三级异动']
watch(
  () => props.formState,
  (val) => {
    getData()
  }
)
watch(
  () => props.distributionType,
  (val) => {
    getData()
  }
)
const getData = () => {
  const queryForm = {
    ...props.formState,
    distributionType: props.distributionType
  }
  spinning.value = true
  if (props.distributionType === '1') {
    getAlarmTypeDistribution(queryForm)
      .then((res: any) => {
        const data = res.data || []
        showECharts.value = true
        initChart(generateAlarmTypeList(data))
      })
      .finally(() => {
        spinning.value = false
      })
  } else {
    getAlarmLevelDistribution(queryForm)
      .then((res: any) => {
        const data = res.data || []
        showECharts.value = true
        initChart(generateLevelList(data))
      })
      .finally(() => {
        spinning.value = false
      })
  }
}

const alarmTypeList = [
  '激活异动',
  '流失异动',
  '余额异动',
  '入库异动',
  '出库异动',
  '在库异动',
  '出库增长异动',
  '入库增长异动'
]
const generateAlarmTypeList = (clueFollowingUpRateList: any) => {
  const datas = alarmTypeList.map(() => [])
  props.formState.region.deptScopeInfo.forEach((employee: any) => {
    const item = clueFollowingUpRateList.find((ii: any) => ii.employeeNo === employee.employeeNo)
    const regionAlarmTypeList = item?.regionAlarmTypeList || []
    alarmTypeList.forEach((type, index) => {
      const alarmItem = regionAlarmTypeList.find((alarm: any) => alarm.name === type)
      datas[index].push(alarmItem?.quantity || 0)
    })
  })
  return datas
}

const generateLevelList = (clueFollowingUpRateList: any) => {
  const datas = alarmTypeList.map(() => [])
  props.formState.region.deptScopeInfo.forEach((employee: any) => {
    const item = clueFollowingUpRateList.find((ii: any) => ii.employeeNo === employee.employeeNo)
    const regionAlarmLevelList = item?.regionAlarmLevelList || []
    levelNames.forEach((type, index) => {
      const alarmItem = regionAlarmLevelList.find((alarm: any) => alarm.name === type)
      datas[index].push(alarmItem?.quantity || 0)
    })
  })
  return datas
}

const pieColors = colors.filter((item) => item !== '#EE6666')
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
const initChart = (data: any[]) => {
  setOptions({
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      itemWidth: 12,
      itemHeight: 2,
      left: 'right',
      icon: 'react',
      right: '50%',
      data: props.distributionType === '1' ? alarmTypeList : levelNames
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: props.formState.region.deptScopeInfo.map((item: any) => item.employeeName)
    },
    yAxis: {
      type: 'value'
    },
    series: data.map((item, index) => ({
      data: item,
      type: 'bar',
      name: props.distributionType === '1' ? alarmTypeList[index] : levelNames[index],
      stack: 'total',
      // label: {
      //   show: true,
      //   position: 'top',
      //   formatter: '{c}%'
      // },
      itemStyle: {
        color: colors[index]
      }
    }))
  })
}
onBeforeMount(() => getData())
</script>
<script lang="ts">
export default { name: 'AlarmDistribution' }
</script>

<style lang="scss" scoped></style>
